module.exports = __webpack_public_path__ + "static/media/train_ticket.681c05a2.svg";